import { Box, Divider, Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import NumberField from "../../../../../components/NumberField/NumberField";
import { translateSubElementString } from "../../../../../utils";

function ManualEmissionsList({ items }) {
  const { t } = useTranslation("translation", { keyPrefix: "reportsPage" });

  if (!items || items.length === 0) return null;

  return (
    <Box marginTop="6">
      <Divider mb={3} />
      <Heading color="esg_gray.200" size="xs" mb={3}>
        {t("manualEmissionsTitle")}
      </Heading>
      <Grid templateColumns="repeat(2, 1fr)" gap={2} overflow="auto">
        <GridItem>
          <Text fontWeight="600" fontSize="sm" color="esg_gray.300">
            {translateSubElementString("reportsPage.totalEmissions")}
          </Text>
        </GridItem>
        <GridItem />
        {items.map((row) => (
          <React.Fragment key={`manual-emission-${row.id}`}>
            <GridItem>
              <Text fontSize="sm">{row.notes || ""}</Text>
            </GridItem>
            <GridItem>
              <NumberField value={row.tco2e} />
            </GridItem>
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
}

export default ManualEmissionsList;
